import './DataTableV2GanttChartGrid.css';
export var ganttChartGridCSS = '_10740f40-2-0-1';